import { SVGProps, Ref, forwardRef } from 'react';

export const VkSquareSolidSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.546 2.546C1 4.093 1 6.582 1 11.56v.88c0 4.978 0 7.467 1.546 9.013S6.582 23 11.56 23h.88c4.978 0 7.467 0 9.013-1.547S23 17.418 23 12.44v-.88c0-4.978 0-7.467-1.547-9.014S17.418 1 12.44 1h-.88C6.582 1 4.093 1 2.546 2.546m2.167 5.146c.119 5.72 2.979 9.157 7.993 9.157h.284v-3.272c1.843.183 3.236 1.53 3.795 3.272h2.603c-.715-2.603-2.594-4.042-3.767-4.592 1.173-.679 2.823-2.329 3.217-4.565h-2.365c-.513 1.815-2.035 3.465-3.483 3.62v-3.62h-2.365v6.343c-1.467-.367-3.318-2.145-3.4-6.343z"
                fill="currentColor"
            />
        </g>
    </svg>
));
VkSquareSolidSize24Glyph.displayName = 'VkSquareSolidSize24Glyph';
